import PropTypes from "prop-types";
import * as React from "react";
import { PROBLEM, messageFor } from "../../../domain/productComposer/problems";
import { Typography } from "../../../themeV2";
import ImageStrip from "../images/ImageStrip";

const IMAGE_PROBLEMS = new Set([
  PROBLEM.NO_IMAGE,
  PROBLEM.IMAGE_NOT_READY,
  PROBLEM.IMAGE_TOO_SMALL,
  PROBLEM.TOO_MANY_IMAGES,
]);

const ImagesSection = function ImagesSection({
  card,
  dispatch,
  uploader,
  problems,
  showErrors,
  readOnly,
}) {
  const imageProblem = problems.find(
    (p) => p.cardId === card.cardId && IMAGE_PROBLEMS.has(p.code),
  );

  return (
    <div>
      <ImageStrip
        images={card.images}
        readOnly={readOnly}
        canEdit={uploader.canEdit}
        onChooseFiles={(files) => uploader.addToCard(card.cardId, files)}
        onEdit={uploader.startEdit}
        onMove={(from, to) =>
          dispatch({ type: "moveImage", cardId: card.cardId, from, to })
        }
        onRemove={(imageId) =>
          dispatch({ type: "removeImage", cardId: card.cardId, imageId })
        }
        onRetry={uploader.retry}
      />
      {showErrors && imageProblem && (
        <Typography variant="body-md" color="error" as="p" role="alert">
          {messageFor(imageProblem)}
        </Typography>
      )}
    </div>
  );
};

ImagesSection.propTypes = {
  card: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  problems: PropTypes.arrayOf(PropTypes.object).isRequired,
  readOnly: PropTypes.bool,
  showErrors: PropTypes.bool,
  uploader: PropTypes.shape({
    addToCard: PropTypes.func.isRequired,
    canEdit: PropTypes.func.isRequired,
    retry: PropTypes.func.isRequired,
    startEdit: PropTypes.func.isRequired,
  }).isRequired,
};

export default ImagesSection;
